import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';
import { modals } from '@/mixins/modal';

export default Vue.component('feedback', {
  template: require('./template.html'),
  name: 'feedback',
  mixins: [guid, modals],
  computed: {
    ...mapGetters(['currentUser', 'identityId']),
  },
  data() {
    return {
      loading: false,
      openFeedback: false,
      hovered: false,
      feedbackmessage: '',
      sendErrors: false,
    };
  },
  mounted() {
    // used for modal mixin
    this.cls = '.adminUi-modalOverlay';
  },
  methods: {
    sendFeedback() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          try {
            this.loading = true;
            this.sendErrors = false;

            await this._SEND([{
              name: 'sendFeedback',
              payload: {
                feedback: this.feedbackmessage,
              },
            }]);

            // send succes notification only
            this.$store.dispatch('addNotification', {
              id: this.guid(),
              type: 'success',
              message: 'Sent! Thank you for your feedback!',
            });
            // reset modal
            this.feedbackmessage = '';
            this.toggleModal('openFeedback');
          } catch (e) {
            this.sendErrors = `${e.message || e}`;
            this.$log.error(e);
            // send error report
            await this._reportError({
              error: e,
              fn: 'sendFeedback',
            });
          } finally {
            this.loading = false;
          }
        }
      });
    },
    toggleModal(type) {
      this[type] = !this[type];
      const content = this.$refs[type];
      if (this[type]) {
        this.modelMoveOut(content);
      } else {
        this.modalMoveIn(content);
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/feedback/index.js